"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconChevronRight = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "-4 0 24 19",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "0.49 18.13 2.26 19.9 12.16 10 2.26 0.1 0.49 1.87 8.62 10 0.49 18.13"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconChevronRight')(IconChevronRight);